export const breadcrumbData = {
  product: {
    taxonomy: {
      breadCrumbs: [
        {
          __typename: 'BreadCrumb',
          dimensionName: 'Category',
          label: 'Home Decor',
          url: '/b/Home-Decor/N-5yc1vZas6p',
          creativeIconUrl: null,
          deselectUrl: null,
          refinementKey: null
        },
        {
          __typename: 'BreadCrumb',
          dimensionName: 'Category',
          label: 'Style Quiz',
          url: '/stylequiz',
          creativeIconUrl: null,
          deselectUrl: null,
          refinementKey: null
        }
      ]
    }
  }
};
